import { IFoThucDonImportRequest, IFoThucDonInsertMultipleRequest, IFoThucDonSelectRequest } from '../../../api/dich-vu/food/foThucDonApi';
import { fo_caan } from '../../../models/response/dich-vu/food/fo_caan';
import { fo_monan_chitiet } from '../../../models/response/dich-vu/food/fo_monan_chitiet';
import { FoThucDonTheoNgayItemResponse } from '../../../models/response/dich-vu/food/fo_thucdon';

/** Payload đổi món ăn của 1 ô trên lưới thực đơn */
export interface IFoThucDonChangeMonAnPayload {
	row_index: number;
	fo_caan_id: number;
	fo_monan_chitiet_ids: number[];
}

export enum eFoThucDonActionTypeIds {
	LOAD_START = "FO_THUCDON_LOAD_START",
	LOAD_SUCCESS = "FO_THUCDON_LOAD_SUCCESS",
	LOAD_ERROR = "FO_THUCDON_LOAD_ERROR",

	LOAD_CAAN_START = "FO_THUCDON_LOAD_CAAN_START",
	LOAD_CAAN_SUCCESS = "FO_THUCDON_LOAD_CAAN_SUCCESS",
	LOAD_CAAN_ERROR = "FO_THUCDON_LOAD_CAAN_ERROR",

	LOAD_MONAN_START = "FO_THUCDON_LOAD_MONAN_START",
	LOAD_MONAN_SUCCESS = "FO_THUCDON_LOAD_MONAN_SUCCESS",
	LOAD_MONAN_ERROR = "FO_THUCDON_LOAD_MONAN_ERROR",

	CHANGE_MONAN = "FO_THUCDON_CHANGE_MONAN",

	SAVE_MULTIPLE_START = "FO_THUCDON_SAVE_MULTIPLE_START",
	SAVE_MULTIPLE_SUCCESS = "FO_THUCDON_SAVE_MULTIPLE_SUCCESS",
	SAVE_MULTIPLE_ERROR = "FO_THUCDON_SAVE_MULTIPLE_ERROR",

	SHOW_IMPORT_MODAL = "FO_THUCDON_SHOW_IMPORT_MODAL",
	CLOSE_IMPORT_MODAL = "FO_THUCDON_CLOSE_IMPORT_MODAL",

	VALIDATE_IMPORT_START = "FO_THUCDON_VALIDATE_IMPORT_START",
	VALIDATE_IMPORT_SUCCESS = "FO_THUCDON_VALIDATE_IMPORT_SUCCESS",
	VALIDATE_IMPORT_ERROR = "FO_THUCDON_VALIDATE_IMPORT_ERROR",

	IMPORT_START = "FO_THUCDON_IMPORT_START",
	IMPORT_SUCCESS = "FO_THUCDON_IMPORT_SUCCESS",
	IMPORT_ERROR = "FO_THUCDON_IMPORT_ERROR"
}

export interface IFoThucDonLoadStart {
	type: eFoThucDonActionTypeIds.LOAD_START,
	payload: IFoThucDonSelectRequest
}
export interface IFoThucDonLoadSuccess {
	type: eFoThucDonActionTypeIds.LOAD_SUCCESS,
	payload?: FoThucDonTheoNgayItemResponse
}
export interface IFoThucDonLoadErr {
	type: eFoThucDonActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IFoThucDonLoadCaAnStart {
	type: eFoThucDonActionTypeIds.LOAD_CAAN_START
}
export interface IFoThucDonLoadCaAnSuccess {
	type: eFoThucDonActionTypeIds.LOAD_CAAN_SUCCESS,
	payload: fo_caan[]
}
export interface IFoThucDonLoadCaAnErr {
	type: eFoThucDonActionTypeIds.LOAD_CAAN_ERROR,
	payload: string
}
export interface IFoThucDonLoadMonAnStart {
	type: eFoThucDonActionTypeIds.LOAD_MONAN_START,
	payload: number
}
export interface IFoThucDonLoadMonAnSuccess {
	type: eFoThucDonActionTypeIds.LOAD_MONAN_SUCCESS,
	payload: fo_monan_chitiet[]
}
export interface IFoThucDonLoadMonAnErr {
	type: eFoThucDonActionTypeIds.LOAD_MONAN_ERROR,
	payload: string
}
export interface IFoThucDonChangeMonAn {
	type: eFoThucDonActionTypeIds.CHANGE_MONAN,
	payload: IFoThucDonChangeMonAnPayload
}
export interface IFoThucDonSaveMultipleStart {
	type: eFoThucDonActionTypeIds.SAVE_MULTIPLE_START,
	payload: IFoThucDonInsertMultipleRequest
}
export interface IFoThucDonSaveMultipleSuccess {
	type: eFoThucDonActionTypeIds.SAVE_MULTIPLE_SUCCESS
}
export interface IFoThucDonSaveMultipleErr {
	type: eFoThucDonActionTypeIds.SAVE_MULTIPLE_ERROR,
	payload: string
}
export interface IFoThucDonShowImportModal {
	type: eFoThucDonActionTypeIds.SHOW_IMPORT_MODAL
}
export interface IFoThucDonCloseImportModal {
	type: eFoThucDonActionTypeIds.CLOSE_IMPORT_MODAL
}
export interface IFoThucDonValidateImportStart {
	type: eFoThucDonActionTypeIds.VALIDATE_IMPORT_START,
	payload: IFoThucDonImportRequest
}
export interface IFoThucDonValidateImportSuccess {
	type: eFoThucDonActionTypeIds.VALIDATE_IMPORT_SUCCESS,
	payload: any[]
}
export interface IFoThucDonValidateImportErr {
	type: eFoThucDonActionTypeIds.VALIDATE_IMPORT_ERROR,
	payload: string
}
export interface IFoThucDonImportStart {
	type: eFoThucDonActionTypeIds.IMPORT_START,
	payload: IFoThucDonImportRequest
}
export interface IFoThucDonImportSuccess {
	type: eFoThucDonActionTypeIds.IMPORT_SUCCESS
}
export interface IFoThucDonImportErr {
	type: eFoThucDonActionTypeIds.IMPORT_ERROR,
	payload: string
}

export type IFoThucDonActionTypes = IFoThucDonLoadStart | IFoThucDonLoadSuccess | IFoThucDonLoadErr |
	IFoThucDonLoadCaAnStart | IFoThucDonLoadCaAnSuccess | IFoThucDonLoadCaAnErr |
	IFoThucDonLoadMonAnStart | IFoThucDonLoadMonAnSuccess | IFoThucDonLoadMonAnErr |
	IFoThucDonChangeMonAn |
	IFoThucDonSaveMultipleStart | IFoThucDonSaveMultipleSuccess | IFoThucDonSaveMultipleErr |
	IFoThucDonShowImportModal | IFoThucDonCloseImportModal |
	IFoThucDonValidateImportStart | IFoThucDonValidateImportSuccess | IFoThucDonValidateImportErr |
	IFoThucDonImportStart | IFoThucDonImportSuccess | IFoThucDonImportErr
